import Tableview from '../../components/commos/Tableview'
import NavigationHeader from '../../components/navigation/NavigationHeader';
import Loading from '../../features/sso-auth/components/Loading';
import { Button } from '@ab-inbev-maz/compass';
import { useTableDataLegals } from '../../hooks/legals/useTableDataLegals';
import type { KeyNameFields, LegalTableItem } from '../../services/legalsService';
import { sanitizeRichTextHtml } from '../../utils/sanitizeRichTextHtml';

const TableLegals = () => {
  const {
    datos,
    loading,
    currentPage,
    totalPages,
    totalCount,
    pageSize,
    searchValue,
    handleCreateLegal,
    handleEdit,
    handlePageChange,
    handlePageSizeChange,
    handleSearchChange,
    handleDelete
  } = useTableDataLegals();

  const columnas:{ key: KeyNameFields, title: string, render?: any, }[] = [
    {
      key: 'name',
      title: 'Nombre',
    },
    {
      key: 'legal_text',
      title: 'Texto legal',
      render: (value: string) => (
        <div className="flex w-full justify-start">
          <div
            className="w-full text-left whitespace-pre-line [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5"
            dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(value) }}
          />
        </div>
      ),
    },
    {
      key: 'color',
      title: 'Color',
      render: (value: string) => (
        <div className="flex items-center gap-2">
          <span
            className="inline-block w-6 h-6 rounded border border-gray-300"
            style={{ backgroundColor: value }}
          />
          <span>{value}</span>
        </div>
      )
    },
    {
      key: 'actions',
      title: 'Acciones',
      render: (_t: undefined, row: LegalTableItem) => (
        <Button label='Editar' rightIcon='functionalities/edit-2' onClick={handleEdit.bind(null, row.id ?? '')} />
      )
    }
  ];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-sm w-full space-y-8 bg-white p-8 rounded-3xl shadow-lg">
          <Loading message="Esto solo va tomar un momento, estamos cargando los legales." />
        </div>
      </div>
    );
  }

  return (
    <>
      <NavigationHeader
        title='Librería de legales'
        description='Desde aquí puedes consultar todos los legales creados y crear nuevos cuando lo necesites.'
        backLink='/'
        actions={[
          <Button
            label="Crear nuevo legal"
            rightIcon="system/document-signed"
            variant="primary"
            onClick={handleCreateLegal}
            className="cursor-pointer"
            data-testid="action-button"
          />
        ]}
      />

      <Tableview
        title='Librería de legales'
        datos={datos}
        columnas={columnas}
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        searchValue={searchValue}
        onSearchChange={handleSearchChange}
        showDownloadButton={false}
        showDeleteButton={true}
        onDelete={handleDelete}
      />
    </>
  )
}

export default TableLegals
